import { Injectable } from '@angular/core';

interface LocalSettings {
  showTagsOnMobile: boolean;
  plannerExpandFixedTags: boolean;
  plannerExpandPeriodicTags: boolean;
  plannerExpandArchivedTags: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class LocalSettingsService {
  private readonly LOCAL_SETTINGS_STORAGE_KEY = 'local-settings';
  private readonly defaultLocalSettings: LocalSettings = {
    showTagsOnMobile: true,
    plannerExpandFixedTags: true,
    plannerExpandPeriodicTags: true,
    plannerExpandArchivedTags: true,
  };

  settings: LocalSettings = this.defaultLocalSettings;

  constructor() {}

  init(): void {
    try {
      const localSettings = JSON.parse(
        localStorage.getItem(this.LOCAL_SETTINGS_STORAGE_KEY) || '{}'
      );
      this.settings = { ...this.defaultLocalSettings, ...localSettings };
    } catch (e) {
      this.settings = this.defaultLocalSettings;
    }
  }

  set(settings: LocalSettings) {
    localStorage.setItem(
      this.LOCAL_SETTINGS_STORAGE_KEY,
      JSON.stringify(settings)
    );
    this.init();
  }
}
